package com.example.hukakmp.reportchat

import com.example.hukakmp.model.EspecieEntry
import com.example.hukakmp.model.ModalidadPesca
import com.example.hukakmp.model.NuevoParteInput

data class ConversationalReportDraft(
    val fecha: String? = null,
    val horaInicio: String? = null,
    val horaFin: String? = null,
    val modalidad: ModalidadPesca? = null,
    val modalidadOtra: String? = null,
    val numeroCanas: Int? = null,
    val nombreLugar: String? = null,
    val zona: String? = null,
    val latitud: String? = null,
    val longitud: String? = null,
    val especies: List<EspecieEntry> = emptyList(),
    val observaciones: String? = null,
    val sinCapturas: Boolean = false,
    val resumen: String = "",
)

sealed interface ConversationalReportResult {
    data class Success(val draft: ConversationalReportDraft) : ConversationalReportResult
    data class Error(val message: String) : ConversationalReportResult
}

expect val conversationalReportAvailable: Boolean

expect suspend fun extractConversationalReport(
    text: String,
): ConversationalReportResult

fun ConversationalReportDraft.toNuevoParteInput(): NuevoParteInput =
    NuevoParteInput(
        fecha = fecha.orEmpty(),
        horaInicio = horaInicio.orEmpty(),
        horaFin = horaFin.orEmpty(),
        modalidad = modalidad,
        modalidadOtra = modalidadOtra.orEmpty(),
        numeroCanas = numeroCanas,
        nombreLugar = nombreLugar.orEmpty(),
        zona = zona.orEmpty(),
        latitud = latitud.orEmpty(),
        longitud = longitud.orEmpty(),
        especies = if (sinCapturas) emptyList() else especies,
        observaciones = observaciones.orEmpty(),
    )
